import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import News3 from "./PV6.jpg"

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
  
    },
  },
  large: {
    width: theme.spacing(20),
    height: theme.spacing(20),
  },
}));

export default function ProfileAvatars() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
       <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        
      </div>
      <Avatar alt="Remy Sharp" src={News3} className={classes.large} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Home/Avatar.js